/* eslint semi:0 */
import { isInIframe, path, } from 'utils/ua'

if (isInIframe && path.isEmbedded) {
  require('iframe-resizer').iframeResizerContentWindow
  // Disabled until we decide to scroll embed host again.
  // let interval = setInterval(function(){
  //   if ('parentIFrame' in window) {
  //     clearInterval(interval);
  //     registerStore()
  //   }
  // }, 32);
}

// Disabled until we decide to scroll embed host again.
// function registerStore(){
//   let { parentIFrame: parentIframe, } = window
//   if (parentIframe) {
//     let { scrollToOffset, } = parentIframe
//     let EmbedGuestProviderStore = require('stores/EmbedGuestProviderStore')
//     EmbedGuestProviderStore.create({ scrollToOffset, })
//   }
// }


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/embed/embedGuestProvider.js